import React from 'react';
import {Box} from '@mui/material';
import {useIsMobile} from '../../hooks';

export interface SplitHeroLayoutProps {
  children: React.ReactNode;
  // Caller-supplied so each page can use its own Figma asset (or share one)
  // rather than this component hardcoding a single image for every caller.
  image: string;
}

// Figma's desktop Pre-review and Sign pages both show a full-height brand
// image in the left ~45% of the screen, with the page's normal
// content to its right — mobile has no such image. Wrap a page's
// BaseFullPage with this only while showing the specific screen Figma
// depicts this way (not every state of that page).
export const SplitHeroLayout: React.FC<SplitHeroLayoutProps> = ({
  children,
  image,
}) => {
  const isMobile = useIsMobile();

  if (isMobile) return <>{children}</>;

  return (
    <Box
      sx={{
        display: 'flex',
        height: '100vh',
        '@supports (height: 100dvh)': {height: '100dvh'},
      }}>
      {/* Figma insets the image from the screen edges with rounded corners
          rather than bleeding it to the edge. */}
      <Box sx={{width: '45%', flexShrink: 0, p: 4, boxSizing: 'border-box'}}>
        <Box
          sx={{
            height: '100%',
            borderRadius: '12px',
            backgroundImage: `url(${image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
      </Box>
      <Box sx={{flex: 1, minWidth: 0}}>{children}</Box>
    </Box>
  );
};

export default SplitHeroLayout;
